module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../../../node_modules/happypack/loader.js?id=jsx!./SelectProductsView.js"));
	}, "AfterSaleSelectProductsView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=AfterSaleSelectProductsView!./src/pages/Shop/Member/TradeManage/AfterSale/ApplyAfterSale/SelectProducts/SelectProductsView.js
// module id = 1547
// module chunks = 418